import { availabilityScoreOverrideControl } from '../access-control/searchAccess.configuration.ts'
import { useDomainAccessControl } from './domain/accessControl'

export const useHasAvailabilityScoreOverride = (retailerId: string) => {
  const hasAccess = useDomainAccessControl()
  return hasAccess(availabilityScoreOverrideControl)
}
